import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertModel } from 'src/app/Core/interfaces/alerts-model';
import { LanguageService } from 'src/app/Core/services/language.service';

@Component({
  selector: 'app-alert-bar',
  templateUrl: './alert-bar.component.html',
  styleUrls: ['./alert-bar.component.scss']
})
export class AlertBarComponent {
  @Input() icon? : string = 'assets/images/alert-icon.svg';
  @Input() alertContents! : AlertModel;
  @Output() buttonClicked = new EventEmitter<any>();

  constructor(private languageService : LanguageService){}

  onClick(event : any){
    this.buttonClicked.emit(event);
  }

  get isLeft() {
    return this.languageService.CurrentLang.IsLeft;
  }
}
